import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { GriddedContentBlock, Caption } from '../../styles/Utility.styles'

export const VideoBlock = styled(GriddedContentBlock)`
  margin-top: 0;

  @media ${DEVICE.tabletL} {
    grid-template-columns: 1fr repeat(4, 2.5fr) 1fr;
  }
`

export const VideoContainer = styled.div`
  grid-column: 2 / 12;

  @media ${DEVICE.tabletL} {
    grid-column: ${({ widthAdjustment }) =>
      widthAdjustment === '25%'
        ? '2 / 3'
        : widthAdjustment === '50%'
        ? '2 / 4'
        : widthAdjustment === '75%'
        ? '2 / 5'
        : '2 / 6'};
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const IFrameContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;

  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`
export const AzureVideo = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  .azuremediaplayer {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  /* hide the in video ad text */
  .amp-content-title-ad {
    display: none;
  }

  .amp-content-title {
    display: none;
  }
`

export const VideoCaption = styled(Caption)`
  grid-column: 2 / 12;
  margin-top: 1.4rem;

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`
